import * as React from 'react';
import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Divider, Drawer, List, ListItem, ListItemIcon, ListItemText, useTheme, withStyles, Popover, Grid } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import DashboardPageContainer from '../dashboard/DashboardPageContainer';
import { Route } from 'react-router-dom';
import { Redirect, Switch } from 'react-router';
import NewOrderPageContainer from '../order/NewOrderPageContainer';
import Link from '@material-ui/core/Link';
import MoreIcon from '@material-ui/icons/MoreVert';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Badge from '@material-ui/core/Badge';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import FilesTableContainer from '../filesTable/FilesTableContainer';
import RxOrderFormPageContainer from '../rxForm/RxFormPageContainer';
import FeedbackPageContainer from '../feedback/FeedbackPageContainer';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Tooltip from '@material-ui/core/Tooltip';
import LiveOrderContainer from '../liveOrderPage/LiveOrderPageContainer';
import CompleteOrderContainer from '../CompleteOrderPage/CompleteOrderPageContainer';
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox';
import ArchiveRoundedIcon from '@material-ui/icons/ArchiveRounded';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import UserProfileContainer from '../userProfile/UserProfileContainer';
import UserAccountContainer from '../userAccount/UserAccountContainer';
import SupervisorAccountRoundedIcon from '@material-ui/icons/SupervisorAccountRounded';
import ThumbsUpDownRoundedIcon from '@material-ui/icons/ThumbsUpDownRounded';
import FeedbackOutlinedIcon from '@material-ui/icons/FeedbackOutlined';
import HoldOrderPageContainer from '../HoldOrderPage/HoldOrderPageContainer';
import ReturnOrderContainer from '../ReturnOrderPage/ReturnOrderPageContainer';
import SupportRequestPageContainer from '../supportRequest/SupportRequestPageContainer';
import SupportPageChatContainer from '../supportPage/SupportPageContainer';
import SupportPageContainer from '../support/SupportPageContainer';
import PausePresentationIcon from '@material-ui/icons/PausePresentation';
// import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import BugReportIcon from '@material-ui/icons/BugReport';
import SettingsIcon from '@material-ui/icons/Settings';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { SearchValue, NotificationsType } from 'src/reducers/landingPage';
// import InputLabel from '@material-ui/core/InputLabel';
import StlViewerPageContainer from '../stlViewer/StlViewerPageContainer';
import CompleteOrderContainerDate from '../CompletedOrderPageDate/CompletedOrderPageContainerDate';
import PaymentRequestPageContainer from '../PaymentRequest/PaymentRequestPageContainer';
import PaymentIcon from '@material-ui/icons/Payment';
import BuildIcon from '@material-ui/icons/Build';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import DesignPreferencePageContainer from '../designPreferences/DesignPreferencePageContainer';
import MaterialFilesUploadContainer from '../MaterialFilesUpload/MaterialFilesUploadContainer';
import RateReviewIcon from '@material-ui/icons/RateReview';
import EditDesignPreferencePageContainer from '../editdesignPreferences/EditDesignPreferencePageContainer';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';
import CancelOrderPageContainer from '../CancelOrderPage/CancelOrderPageContainer';
import FiberNewOutlinedIcon from '@material-ui/icons/FiberNewOutlined';
import NewOrdersPageContainer from '../NewOrdersPage/NewOrdersPageContainer';
import { UserDetail } from 'src/reducers/user';
import UnderDesignContainer from '../UnderDesign/UnderDesignContainer';
import DesignReadyContainer from '../DesignReady/DesignReadyContainer';
import MHoldOrderContainer from '../MHoldOrder/MHoldOrderPageContainer';
import MNewOrderContainer from '../MNewOrdersPage/MNewOrdersPageContainer';
import MInproductionContainer from '../MInproduction/MInproductionContainer';
import TransactionPageContainer from '../TransactionPage/TransactionPageContainer';
import MFilterOrderContainer from '../MFilterOrder/MFilterOrderContainer';
import MFilterLessOrderContainer from '../MFilterLessOrder/MFilterLessOrderContainer';
import PaymentConfirmationContainer from '../PaymentConfirmation/PaymentConfirmationContainer';
import PaidInvoicePageContainer from '../PaidInvoice/PaidInvoicePageContainer';
import MCompleteOrderContainer from '../MCompleteOrder/MCompleteContainer';
import CFilterOrderContainer from '../CFilterOrder/CFilterOrderContainer';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
// import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ReceiptIcon from '@material-ui/icons/Receipt';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper, { PaperProps } from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { DialogProps } from '@material-ui/core/Dialog/Dialog';
import { UserProfileData } from '../../reducers/userProfile';
import OrderRawDataContainer from '../OrderRawDataPage/OrderRawDataContainer';
import MyInvoicesContainer from '../MyInvoices/MyInvoicesContainer';
import NotificationsContainer from '../Notifications/NotificationsContainer';
import PrintClientView from './PrintClientErrorView';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MFilesTableContainer from '../MfilesTable/MFilesTableContainer';
import SupportFeedbackView from './SupportFeedbackView';
import { Modal } from '@material-ui/core';
import Card from '../../materialcomponents/Card/Card';
import { Link as RouterLink } from 'react-router-dom';
import FeedbackListContainer from '../feedbackRequest/FeedbackListContainer';
import ViewFeedbackPageContainer from '../feedback/ViewFeedbackPageContainer';
import ManuCompleteOrderContainer from '../ManuCompleteOrderPage/ManuCompleteOrderPageContainer';

// import { push } from 'react-router-redux';
// import ReactPlayer from 'react-player';

function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}
// const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 400,
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     boxShadow: 24,
//     p: 4,
// };

export interface HomePageProps {
    btnElement: string;
    userDetails: UserDetail;
    addNewOrder: () => void;
    MUploadOrder: () => void;
    profilePage: () => void;
    goHome: () => void;
    feedback: () => void;
    logout: () => void;
    draftOrder: () => void;
    newOrder: () => void;
    liveOrder: () => void;
    completeOrder: () => void;
    manucompletedOrder: () => void;
    orderrawdata: () => void;
    completeOrderDate: () => void;
    ordersOnHold: () => void;
    ordersReturned: () => void;
    cancelOrder: () => void;
    mOnHold: () => void;
    mUnderDesign: () => void;
    mDesignReady: () => void;
    mnewcase: () => void;
    mproduction: () => void;
    mcompleted: () => void;
    cfilterOrder: () => void;
    mfilterOrder: () => void;
    mfilterLessOrder: () => void;
    goUserAccount: () => void;
    goSupport: () => void;
    goFeedback: () => void;
    searchName: (searchName: string) => void;
    searchResult: SearchValue[];
    onViewOrder: (orderid: string, rowData: string) => void;
    searchTrue: boolean;
    searchNameText: string;
    searchType: (searchType: string) => void;
    searchTypeName: string;

    userProfileData: UserProfileData;

    notifications: NotificationsType[];
    notificationsCount: Number;
    readNotifications: (messageId: string) => void;
    goNotification: () => void;
    goPayment: () => void;
    goPaidInvoice: () => void;
    goMyinvoices: () => void;
    goDesignPreference: () => void;
    goMaterialFiles: () => void;

    openVideoPlayer: boolean;
    loader: boolean;
    videoSignedUrl: string[];
    closeVideoPlayer: () => void;
}
const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            height: '100vh'
        },
        appBar: {
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            width: drawerWidth,
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
            justifyContent: 'center',
        },
        logo: {
            padding: '8px 4px',
            height: '70px',
            width: 'auto'
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: -drawerWidth,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        },
        grow: {
            flexGrow: 1,
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        sectionMobile: {
            display: 'flex',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
        search: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: fade(theme.palette.common.white, 0.15),
            '&:hover': {
                backgroundColor: fade(theme.palette.common.white, 0.25),
            },
            marginLeft: 0,
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                marginLeft: theme.spacing(1),
                width: 'auto',
            },
        },
        searchIcon: {
            padding: theme.spacing(0, 2),
            height: '100%',
            position: 'absolute',
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        inputRoot: {
            color: 'inherit',
        },
        inputInput: {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
            transition: theme.transitions.create('width'),
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: '12ch',
                '&:focus': {
                    width: '20ch',
                },
            },
        },
        formControl: {
            // margin: theme.spacing(1),
            minWidth: 120,
            backgroundColor: '#fff',
            borderRadius: '4px',
            '& .MuiOutlinedInput-root': {
                height: '36px'
            }
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        searchResult: {
            position: 'absolute',
            maxHeight: '200px',
            backgroundColor: '#fff',
            width: '400px',
            border: '1px solid #ddd',
            top: '43px',
            zIndex: 5,
            overflowY: 'auto'
        },
        listStyle: {
            color: '#000',
            listStyle: 'none',
            padding: '5px',
            border: '1px solid gray',
            cursor: 'pointer',
            wordBreak: 'break-all'
        },
        popedBox: {
            maxHeight: '250px',
            width: '300px',
            overflowY: 'auto',
            border: '1px solid #d4d4d4',
            borderBottom: 'none',
            borderTop: 'none',
            cursor: 'pointer'
        },
        notifications: {
            cursor: 'pointer',
            padding: theme.spacing(1),
            borderBottom: '1px solid #d4d4d4',
            '&:hover': {
                backgroundColor: '#e9e9e9'
            }
        },
        collapse: {
            minHeight: 'auto !important'
        },
        button: {
            margin: theme.spacing(1),
        },
        list: {
            paddingTop: '4px',
            paddingBottom: '4px'
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        gridSec: {
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            marginBottom: '15px'
        },
        popup: {
            textAlign: 'center',
        },
        btngreen: {
            backgroundColor: '#92D050',
        },
        btnorange: {
            backgroundColor: '#ffc001',
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outlineStyle: 'none',
            boxShadow: 'none',
            borderColor: 'transparent',
            '& :focus': {
                outline: 'none'
            }
        },
        card: {
            maxWidth: 550
        }
    }),
);

const ListItemStyle = withStyles({
    root: {
        paddingTop: '0',
        paddingBottom: '4px',
        '& .MuiListItemText-root': {
            '& .MuiTypography-body1': {
                fontSize: '14px'
            }
        }
    },
})(ListItem);

export const LandingHomePage: React.StatelessComponent<HomePageProps> = (props) => {
    const classes = useStyles({});

    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    // const [navOpen, setNavOpen] = React.useState(true);
    const [orderOpen, setorderOpen] = React.useState(props.userDetails.ugroup === 'Lab' ? false : true);
    const [paymentOpen, setpaymentOpen] = React.useState(false);
    const [profileOpen, setprofileOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    // const handleClick = () => {
    //     setNavOpen(!navOpen);
    // };
    const orderNav = () => {
        setorderOpen(!orderOpen);
    };
    const paymentNav = () => {
        setpaymentOpen(!paymentOpen);
    };
    const profileNav = () => {
        setprofileOpen(!profileOpen);
    };

    const viewOrderScreen = (locationUrl: string) => {
        if (locationUrl.split('designconnect/')[1] === 'app/rxform') {
            return false;
        }
        return true;
    };

    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);

    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const [anchorElNot, setAnchorElNot] = React.useState<HTMLButtonElement | null>(null);
    const handleClickNotification = (event: React.MouseEvent<HTMLButtonElement>) => {
        // setAnchorElNot(event.currentTarget);
        props.goNotification();
    };
    const handleCloseNotification = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNot(null);
        props.goNotification();
    };
    const openNot = Boolean(anchorElNot);
    const idNot = open ? 'simple-popover' : undefined;

    const menuId = 'primary-search-account-menu';
    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem>
                <IconButton onClick={props.goHome} aria-label="show 4 new mails" color="inherit">
                    <HomeRoundedIcon />
                </IconButton>
            </MenuItem>
            <MenuItem>
                <IconButton onClick={handleClickNotification} aria-label="show 17 new notifications" color="inherit">
                    <Badge badgeContent={props.notificationsCount} color="secondary">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
            </MenuItem>
            {
                props.userDetails.ugroup === 'Lab' &&
                <MenuItem>
                    <IconButton
                        aria-label="account of current user"
                        aria-controls={menuId}
                        aria-haspopup="true"
                        onClick={props.profilePage}
                        color="inherit"
                    >
                        <AccountCircle />
                    </IconButton>
                </MenuItem>
            }
            <MenuItem>
                <IconButton
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={props.logout}
                    color="inherit"
                >
                    <ExitToAppIcon />
                </IconButton>
            </MenuItem>
        </Menu>
    );
    // const searchInputChange =  (value:string)=> { 
    //         renderSearchResultsDiv( props.searchName(value));   
    // }
    const renderSearchResultsDiv = (
        <div className={classes.searchResult}>
            {props.searchResult?.map(s => <li className={classes.listStyle} key={s.rowno} onClick={() => s.orderno && props.onViewOrder(s.orderno, s.dsordersid)}>{s.sresult}</li>)}
        </div>
    );

    // const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('sm');

    const popCheck = props.userDetails;
    const [openSec, setOpenSec] = React.useState(true);
    React.useEffect(
        () => {
            if (popCheck.dmeRequired === '1') {
                setOpenSec(false);
            } else {
                setOpenSec(true);
            }
        },
        [popCheck]);
    // const handleOpen = () => {
    //     // push('/app/designpreference');
    //     // window.location.href = '/app/designpreference';
    // };
    const handleClose = () => {
        setOpenSec(false);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Link
                        component="button"
                        className={clsx(classes.menuButton, open && classes.hide)}
                        onClick={props.goHome}
                    >
                        <Typography style={{ color: 'white' }} variant="h6" noWrap>Easyconnect</Typography>
                    </Link>
                    {
                        viewOrderScreen(window.location.href) === true ?
                            <FormControl variant="outlined" className={classes.formControl}>
                                {/* <InputLabel htmlFor="outlined-age-native-simple">Order/Case Number</InputLabel> */}
                                <Select
                                    onChange={event => props.searchType(event.target.value as string)}
                                    // labelWidth={search}
                                    inputProps={{
                                        name: 'age',
                                        id: 'outlined-age-native-simple',
                                    }}
                                    defaultValue=""
                                    value={props.searchTypeName}
                                >
                                    <MenuItem disabled value="">Choose Search</MenuItem>
                                    <MenuItem value="Order No">Order No</MenuItem>
                                    <MenuItem value="File Name">File Name</MenuItem>
                                </Select>
                            </FormControl>
                            :
                            <Button
                                variant="contained"
                                color="primary"
                                disableElevation
                                onClick={() => window.history.back()}
                            >
                                GO BACK
                            </Button>
                    }
                    {
                        viewOrderScreen(window.location.href) === true ?
                            <div className={classes.search}>
                                <div className={classes.searchIcon}>
                                    <SearchIcon />
                                </div>
                                <InputBase
                                    placeholder="Search…"
                                    classes={{
                                        root: classes.inputRoot,
                                        input: classes.inputInput,
                                    }}
                                    inputProps={{ 'aria-label': 'search' }}
                                    onChange={event => props.searchName(event.target.value)}
                                    value={props.searchNameText}
                                />
                                {props.searchTrue && Array.isArray(props.searchResult) && props.searchResult.length > 0 && renderSearchResultsDiv}
                            </div>
                            :
                            null
                    }
                    <div className={classes.grow} />
                    <div className={classes.sectionDesktop}>
                        <IconButton onClick={props.goHome} aria-label="show 4 new mails" color="inherit">
                            <Tooltip title="Home" aria-label="add">
                                <HomeRoundedIcon />
                            </Tooltip>
                        </IconButton>
                        <IconButton onClick={handleClickNotification} aria-label="show 17 new notifications" color="inherit">
                            <Badge badgeContent={props.notificationsCount} color="secondary">
                                <Tooltip title="Notification" aria-label="add">
                                    <NotificationsIcon />
                                </Tooltip>
                            </Badge>
                        </IconButton>
                        <Popover
                            id={idNot}
                            open={openNot}
                            anchorEl={anchorElNot}
                            onClose={handleCloseNotification}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <div className={classes.popedBox}>
                                <List>
                                    {props.notificationsCount > 0 && Array.isArray(props.notifications) && props.notifications.length > 0 ? props.notifications.map((notification) => (
                                        notification.status !== '1' ?
                                            <ListItem
                                                className={classes.notifications}
                                                key={notification.rowno}
                                                onClick={() => props.readNotifications(notification.id)}
                                            >
                                                {notification.message}
                                            </ListItem>
                                            : null
                                    )) : <div style={{ margin: theme.spacing(2), textAlign: 'center' }}>No Notifications</div>}
                                </List>
                            </div>
                        </Popover>
                        {
                            props.userDetails.ugroup === 'Lab' &&
                            <IconButton
                                aria-label="account of current user"
                                aria-controls={menuId}
                                aria-haspopup="true"
                                onClick={props.profilePage}
                                color="inherit"
                            >
                                <Tooltip title="Profile" aria-label="add">
                                    <AccountCircle />
                                </Tooltip>
                            </IconButton>
                        }
                        <Tooltip title="logout" aria-label="logout">
                            <Button
                                variant="contained"
                                size="large"
                                color="default"
                                className={classes.button}
                                onClick={props.logout}
                                endIcon={<ExitToAppIcon />}
                            >
                                {props.userDetails.userName}
                            </Button>
                        </Tooltip>
                    </div>
                    <div className={classes.sectionMobile}>
                        <IconButton
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                        >
                            <MoreIcon />
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
            {renderMobileMenu}
            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <img src="/assets/logoheader.png" title="EasyDent" className={classes.logo} />
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List className={classes.list}>
                    <ListItemStyle button onClick={props.goHome} key="Home">
                        <ListItemIcon>
                            <HomeRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Home" />
                    </ListItemStyle>
                </List>
                {props.userDetails.ugroup === 'Lab' &&
                    <div>
                        <List className={classes.list}>
                            <ListItemStyle button onClick={props.addNewOrder} key="New Order">
                                <ListItemIcon>
                                    <CloudUploadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Upload Order(s)" />
                            </ListItemStyle>
                        </List>
                        <ListItemStyle button onClick={orderNav}>
                            <ListItemIcon>
                                <FormatListBulletedIcon />
                            </ListItemIcon>
                            <ListItemText primary="My Orders" />
                            {orderOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemStyle>
                        <Collapse in={orderOpen} timeout="auto" unmountOnExit className={classes.collapse}>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.newOrder} className={classes.nested}>
                                    <ListItemIcon>
                                        <FiberNewOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="New" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.liveOrder} className={classes.nested}>
                                    <ListItemIcon>
                                        <MarkunreadMailboxIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Live" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.ordersOnHold} className={classes.nested}>
                                    <ListItemIcon>
                                        <PausePresentationIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="on Hold" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.ordersReturned} className={classes.nested}>
                                    <ListItemIcon>
                                        <BuildIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="In Production" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.completeOrder} className={classes.nested}>
                                    <ListItemIcon>
                                        <DoneAllIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Completed" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.cancelOrder} className={classes.nested}>
                                    <ListItemIcon>
                                        <CancelSharpIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Cancelled" />
                                </ListItemStyle>
                            </List>
                        </Collapse>
                    </div>
                }
                {
                    (props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL') &&
                    <div>
                        <List className={classes.list}>
                            <ListItemStyle button onClick={props.MUploadOrder}>
                                <ListItemIcon>
                                    <CloudUploadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Upload Order(s)" />
                            </ListItemStyle>
                        </List>
                        <ListItemStyle button onClick={orderNav}>
                            <ListItemIcon>
                                <FormatListBulletedIcon />
                            </ListItemIcon>
                            <ListItemText primary="My Cases" />
                            {orderOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemStyle>
                        <Collapse in={orderOpen} timeout="auto" unmountOnExit className={classes.collapse}>
                            {/* <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.mnewcase} className={classes.nested}>
                                    <ListItemIcon>
                                        <FiberNewOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="New Cases" />
                                </ListItemStyle>
                            </List> */}
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.mUnderDesign} className={classes.nested}>
                                    <ListItemIcon>
                                        <MarkunreadMailboxIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Design&nbsp;In&nbsp;Progress" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.mOnHold} className={classes.nested}>
                                    <ListItemIcon>
                                        <PausePresentationIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Cases&nbsp;on&nbsp;Hold" />
                                </ListItemStyle>
                            </List>
                            {/* <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.mDesignReady} className={classes.nested}>
                                    <ListItemIcon>
                                        <CheckCircleOutlineIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Design Ready" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.mproduction} className={classes.nested}>
                                    <ListItemIcon>
                                        <BuildIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="In Production" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.mcompleted} className={classes.nested}>
                                    <ListItemIcon>
                                        <DoneAllIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Completed" />
                                </ListItemStyle>
                            </List> */}
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.manucompletedOrder} className={classes.nested}>
                                    <ListItemIcon>
                                        <DoneAllIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Completed" />
                                </ListItemStyle>
                            </List> 
                            <List className={classes.list}>
                                <ListItemStyle button onClick={props.mfilterOrder} key="Allcases">
                                    <ListItemIcon>
                                        <ClearAllIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Order&nbsp;List" />
                                </ListItemStyle>
                            </List>
                            <List className={classes.list}>
                                <ListItemStyle button onClick={props.mfilterLessOrder} key="Allcases">
                                    <ListItemIcon>
                                        <SettingsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Production Status" />
                                </ListItemStyle>
                            </List>
                        </Collapse>
                    </div>
                }
                {/* <List>
                    <ListItemStyle button onClick={props.feedback} key="Feedback">
                        <ListItemIcon>
                            <FeedbackIcon />
                        </ListItemIcon>
                        <ListItemText primary="Feedback" />
                    </ListItemStyle>
                </List> */}
                <List className={classes.list}>
                    <ListItemStyle button onClick={props.goSupport} key="Support">
                        <ListItemIcon>
                            <ThumbsUpDownRoundedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Support" />
                    </ListItemStyle>
                </List>
                <List className={classes.list}>
                    <ListItemStyle button onClick={props.goFeedback} key="Feedback">
                        <ListItemIcon>
                            <FeedbackOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Feedback" />
                    </ListItemStyle>
                </List>
                {props.userDetails.ugroup === 'Lab' &&
                    <div>
                        <ListItemStyle button onClick={profileNav}>
                            <ListItemIcon>
                                <RateReviewIcon />
                            </ListItemIcon>
                            <ListItemText primary="Profile" />
                            {profileOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemStyle>
                        <Collapse in={profileOpen} timeout="auto" unmountOnExit className={classes.collapse}>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.goUserAccount} className={classes.nested} key="User Accounts">
                                    <ListItemIcon>
                                        <SupervisorAccountRoundedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="User Accounts" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.goDesignPreference} className={classes.nested} key="Design Preferences">
                                    <ListItemIcon>
                                        <RateReviewIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Design Preferences" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.goMaterialFiles} className={classes.nested} key="Material Files (DME)">
                                    <ListItemIcon>
                                    <CloudUploadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Material Files (DME)" />
                                </ListItemStyle>
                            </List>
                        </Collapse>
                        <ListItemStyle button onClick={paymentNav}>
                            <ListItemIcon>
                                <PaymentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Payment" />
                            {paymentOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemStyle>
                        <Collapse in={paymentOpen} timeout="auto" unmountOnExit className={classes.collapse}>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.goPayment} className={classes.nested} key="Payment">
                                    <ListItemIcon>
                                        <PaymentIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Make Payment" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.goMyinvoices} className={classes.nested} key="My Invoices">
                                    <ListItemIcon>
                                        <ReceiptOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="My Invoices" />
                                </ListItemStyle>
                            </List>
                            <List component="div" disablePadding>
                                <ListItemStyle button onClick={props.goPaidInvoice} className={classes.nested} key="Paid Invoice">
                                    <ListItemIcon>
                                        <ReceiptIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Payment History" />
                                </ListItemStyle>
                            </List>
                        </Collapse>
                        {/* <List className={classes.list}>
                            <ListItemStyle button onClick={props.cfilterOrder} key="Allcases">
                                <ListItemIcon>
                                    <ClearAllIcon />
                                </ListItemIcon>
                                <ListItemText primary="Order&nbsp;Search by&nbsp;batch" />
                            </ListItemStyle>
                        </List> */}
                        {
                            props.userProfileData.isbatch === 'T' &&
                            <List className={classes.list}>
                                <ListItemStyle button onClick={props.mfilterLessOrder} key="Allcases">
                                    <ListItemIcon>
                                        <SettingsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Production Status" />
                                </ListItemStyle>
                            </List>
                        }
                        <List className={classes.list}>
                            <ListItemStyle button onClick={props.orderrawdata} key="orderrawdata">
                                <ListItemIcon>
                                    <BugReportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Daily Order Report" />
                            </ListItemStyle>
                        </List>
                        <List className={classes.list}>
                            <ListItemStyle button onClick={props.completeOrderDate} key="Archive">
                                <ListItemIcon>
                                    <ArchiveRoundedIcon />
                                </ListItemIcon>
                                <ListItemText primary="Archive" />
                            </ListItemStyle>
                        </List>
                    </div>
                }
            </Drawer>
            <main
                className={clsx(useStyles({}).content, {
                    [useStyles({}).contentShift]: open,
                })}
            >
                <div className={classes.drawerHeader} />
                <Switch>
                    <Route exact path="/app/home" component={DashboardPageContainer} />
                    <Route path="/app/addorder" component={NewOrderPageContainer} />
                    <Route path="/app/neworder" component={FilesTableContainer} />
                    <Route path="/app/uploadorder" component={MFilesTableContainer} />
                    <Route path="/app/profile" component={UserProfileContainer} />
                    <Route path="/app/rxform" component={RxOrderFormPageContainer} />
                    <Route path="/app/feedback" component={FeedbackPageContainer} />
                    <Route path="/app/viewfeedback" component={ViewFeedbackPageContainer} />
                    <Route path="/app/newOrders" component={NewOrdersPageContainer} />
                    <Route path="/app/liveOrders" component={LiveOrderContainer} />
                    <Route path="/app/completeOrders" component={CompleteOrderContainer} />
                    <Route path="/app/orderSearch" component={CFilterOrderContainer} />
                    <Route path="/app/archives" component={CompleteOrderContainerDate} />
                    <Route path="/app/dailyorderreport" component={OrderRawDataContainer} />
                    <Route path="/app/useraccount" component={UserAccountContainer} />
                    <Route path="/app/supportticket" component={SupportRequestPageContainer} />
                    <Route path="/app/feedbacklist" component={FeedbackListContainer} />
                    <Route path="/app/support" component={SupportPageContainer} />
                    <Route path="/app/supportchat" component={SupportPageChatContainer} />
                    <Route path="/app/ordersOnHold" component={HoldOrderPageContainer} />
                    <Route path="/app/inproduction" component={ReturnOrderContainer} />
                    <Route path="/app/cancelorder" component={CancelOrderPageContainer} />
                    <Route path="/app/stlviewer" component={StlViewerPageContainer} />
                    <Route path="/app/paymentinvoices" component={PaymentRequestPageContainer} />
                    <Route path="/app/payment" component={PaymentConfirmationContainer} />
                    <Route path="/app/designpreference" component={DesignPreferencePageContainer} />
                    <Route path="/app/materialfilesupload" component={MaterialFilesUploadContainer} />
                    <Route path="/app/editdesignpreferences" component={EditDesignPreferencePageContainer} />
                    <Route path="/app/underdesigning" component={UnderDesignContainer} />
                    <Route path="/app/designready" component={DesignReadyContainer} />
                    <Route path="/app/casesOnHold" component={MHoldOrderContainer} />
                    <Route path="/app/newcases" component={MNewOrderContainer} />
                    <Route path="/app/caseInproduction" component={MInproductionContainer} />
                    <Route path="/app/caseCompleted" component={MCompleteOrderContainer} />
                    <Route path="/app/allcases" component={MFilterOrderContainer} />
                    <Route path="/app/productionstatus" component={MFilterLessOrderContainer} />
                    <Route path="/app/paymentstatus" component={TransactionPageContainer} />
                    <Route path="/app/paymentHistory" component={PaidInvoicePageContainer} />
                    <Route path="/app/myinvoices" component={MyInvoicesContainer} />
                    <Route path="/app/notifications" component={NotificationsContainer} />
                    <Route path="/app/printclient" component={PrintClientView} />
                    <Route path="/app/support-feedback" component={SupportFeedbackView} />
                    <Route path="/app/manuCompleteOrders" component={ManuCompleteOrderContainer} />
                    <Redirect exact from="/app" to="/app/home" />
                </Switch>
                <Backdrop className={classes.backdrop} open={props.loader}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Dialog
                    open={props.openVideoPlayer}
                    onClose={props.closeVideoPlayer}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                    maxWidth={maxWidth}
                >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        Video
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={2}>
                            {
                                props.videoSignedUrl.length > 0 ? props.videoSignedUrl.map((videoUrl, indexVid) => (
                                    <Grid item xs={12}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <video width="384" height="216" controls autoPlay={indexVid === 0}>
                                                <source src={videoUrl} type="video/webm" />
                                                <source src={videoUrl} type="video/mp4" />
                                            </video>
                                            {/* <ReactPlayer width="384" height="216" controls playing={indexVid === 0} muted url={videoUrl} /> */}
                                            <Button
                                                size="small"
                                                onClick={() => window.open(videoUrl)}
                                                color="primary"
                                            >
                                                Download
                                            </Button>
                                        </div>
                                        <br />
                                    </Grid>
                                ))
                                    :
                                    'No video available. please try again later!'
                            }
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={props.closeVideoPlayer} color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </main>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={openSec}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                disableBackdropClick
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Card className={classes.card} >
                    <h4 className={classes.popup}>Please update design preferences and material files.</h4>
                    <div className={classes.gridSec}>
                        <RouterLink to={'/app/designpreference'} className={classes.link}>
                            <Button className={classes.btngreen} onClick={handleClose}>Update</Button>
                        </RouterLink>
                        <Button onClick={handleClose} className={classes.btnorange}>Skip</Button>
                    </div>

                </Card>
            </Modal>
        </div >

    );
};

export default LandingHomePage;



// WEBPACK FOOTER //
// ./src/components/layouts/LandingHomePage.tsx